import type { Action } from 'redux-actions';
import { put, take, takeEvery } from 'redux-saga/effects';

import { sagaApiGenWithPromise } from 'utils/sagaApiGeneratorHelpers';

import { holdMusicActions } from '../../../holdMusic/actions/holdMusicActions';
import type { FileUploadResponseT } from '../../../holdMusic/components/types';
import { waitMusicActions } from '../../../waitMusic/actions/waitMusicActions';
import { getAllMusic, musicSplit, uploadFile } from '../api/waitHoldMusic';

export const {
  waitMusicGetAll,
  waitMusicGetAllSucceeded,
  waitMusicGetAllFailed,
  waitMusicUpload,
  waitMusicUploadSucceeded,
  waitMusicUploadFailed,
  waitMusicSplit,
  waitMusicSplitSucceeded,
  waitMusicSplitFailed,
  waitMusicSelect,
  waitMusicReset,
  waitMusicShowModal,
  waitMusicHideModal,
  waitMusicWsUploadStatus,
} = waitMusicActions;

export const {
  holdMusicGetAll,
  holdMusicGetAllSucceeded,
  holdMusicGetAllFailed,
  holdMusicUpload,
  holdMusicUploadSucceeded,
  holdMusicUploadFailed,
  holdMusicSplit,
  holdMusicSplitSucceeded,
  holdMusicSplitFailed,
  holdMusicSelect,
  holdMusicReset,
  holdMusicShowModal,
  holdMusicHideModal,
  holdMusicWsUploadStatus,
} = holdMusicActions;

// We refetch all the audios after a wait music ws event was completed.
function* waitMusicWsUploadStatusGen(action: Action<FileUploadResponseT>) {
  try {
    if (action.payload) {
      yield put(waitMusicGetAll());
      const actionResponse = yield take(waitMusicGetAllSucceeded);
      if (
        actionResponse.payload.data &&
        actionResponse.payload.data.wait_music
      ) {
        for (const music of actionResponse.payload.data.wait_music) {
          if (music.uuid === action.payload.job_id) {
            const currentMusic = Object.assign({}, music, { id: music.uuid });
            yield put(waitMusicSelect({ selectedAudio: currentMusic }));
          }
        }
      }
    }
  } catch (e) {
    console.error('Exception waitMusicWsUploadStatusGen:', e);
  }
}

// We refetch all the audios after an hold music ws event was completed.
function* holdMusicWsUploadStatusGen(action: Action<FileUploadResponseT>) {
  try {
    if (action.payload) {
      yield put(holdMusicGetAll());
      const actionResponse = yield take(holdMusicGetAllSucceeded);

      if (
        actionResponse.payload.data &&
        actionResponse.payload.data.wait_music
      ) {
        for (const music of actionResponse.payload.data.wait_music) {
          if (music.uuid === action.payload.job_id) {
            const currentMusic = Object.assign({}, music, { id: music.uuid });
            yield put(holdMusicSelect({ selectedAudio: currentMusic }));
          }
        }
      }
    }
  } catch (e) {
    console.error('Exception holdMusicWsUploadStatusGen:', e);
  }
}

// Wait music Saga
export const waitMusic = [
  takeEvery(
    waitMusicGetAll.toString(),
    sagaApiGenWithPromise(
      getAllMusic,
      waitMusicGetAllSucceeded,
      waitMusicGetAllFailed,
    ),
  ),
  takeEvery(
    waitMusicUpload.toString(),
    sagaApiGenWithPromise(
      uploadFile,
      waitMusicUploadSucceeded,
      waitMusicUploadFailed,
    ),
  ),
  takeEvery(
    waitMusicSplit.toString(),
    sagaApiGenWithPromise(
      musicSplit,
      waitMusicSplitSucceeded,
      waitMusicSplitFailed,
    ),
  ),
  takeEvery(waitMusicWsUploadStatus.toString(), waitMusicWsUploadStatusGen),
];

// Hold music Saga
export const holdMusic = [
  takeEvery(
    holdMusicGetAll.toString(),
    sagaApiGenWithPromise(
      getAllMusic,
      holdMusicGetAllSucceeded,
      holdMusicGetAllFailed,
    ),
  ),
  takeEvery(
    holdMusicUpload.toString(),
    sagaApiGenWithPromise(
      uploadFile,
      holdMusicUploadSucceeded,
      holdMusicUploadFailed,
    ),
  ),
  takeEvery(
    holdMusicSplit.toString(),
    sagaApiGenWithPromise(
      musicSplit,
      holdMusicSplitSucceeded,
      holdMusicSplitFailed,
    ),
  ),
  takeEvery(holdMusicWsUploadStatus.toString(), holdMusicWsUploadStatusGen),
];
